import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useWorkspace } from '../../contexts/WorkspaceContext';
import {
  temModuloFinanceiro,
  temModuloMilhas,
  temAlgumModulo,
  temModoPrestador,
} from '../../utils/moduloAccess';

const ModuloRoute = ({ modulo, children }) => {
  const { user, isAuthenticated } = useAuth();
  const { emWorkspaceCompartilhado, resolvendoWorkspace } = useWorkspace() || {};

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (resolvendoWorkspace) {
    return <div style={{ display: 'flex', justifyContent: 'center', marginTop: 60 }}>Carregando...</div>;
  }

  // No workspace de outra pessoa, quem concede os módulos é o titular (o backend
  // valida). O modo prestador segue sendo do próprio usuário.
  if (emWorkspaceCompartilhado && modulo !== 'prestador') {
    return children;
  }

  let allowed = true;
  if (modulo === 'financeiro') {
    allowed = temModuloFinanceiro(user);
  } else if (modulo === 'milhas') {
    allowed = temModuloMilhas(user);
  } else if (modulo === 'qualquer') {
    allowed = temAlgumModulo(user);
  } else if (modulo === 'prestador') {
    allowed = temModoPrestador(user);
  }

  if (!allowed) {
    return <Navigate to={modulo === 'prestador' ? '/configuracoes' : '/meu-plano'} replace />;
  }

  return children;
};

export default ModuloRoute;
